export default __webpack_public_path__ + "static/media/trash_del.430de2a8.svg";